import './style.scss';
import { IProjectDocInfoTags } from '../../../model/api-modules/document';
import { LanguageType } from '../../../model';

interface IProps {
  readonly inductionTags: ReadonlyArray<IProjectDocInfoTags> | undefined;
  readonly joinPath: (projectId: string, docId?: string) => void;
  readonly setSelectActive: (value: ReadonlyArray<number>) => void;
  readonly lang: LanguageType | null;
}

export const QuickAccess = (props: IProps) => {
  return (
    <div>
      <p className="c-title mt">
        {props.lang === LanguageType.EN ? 'Quick Access' : '快速访问'}
      </p>
      <ul className="c-induction">
        {props.inductionTags &&
          props.inductionTags.length > 0 &&
          props.inductionTags.map(
            (item: IProjectDocInfoTags, index: number) => {
              return (
                item.list?.length > 0 && (
                  <li key={index} className="i-list">
                    <div className="list-title">
                      <span>{item.name}</span>
                    </div>
                    <ul>
                      {item.list?.length > 0 &&
                        item.list.map((tagItem: any, tagIndex: number) => {
                          return (
                            <li
                              key={tagIndex}
                              onClick={() => {
                                props.joinPath(tagItem.project_id, tagItem.id);
                                props.setSelectActive([tagItem.id]);
                              }}
                            >
                              {tagItem.title}
                            </li>
                          );
                        })}
                    </ul>
                  </li>
                )
              );
            }
          )}
      </ul>
    </div>
  );
};
